import React from 'react';
import { Slide } from '@mui/material';

const SlideTransition = React.forwardRef(function SlideTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default SlideTransition;
